import React, { useContext } from 'react';
import { Table, Button, Modal, message } from 'antd';
import { withRouter } from 'react-router-dom';
import goto from '@/common/goto';
import { getQuery } from '@/common/utils';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import TableContentCopy from './../../components/table-content-copy';
import TableContactUser from './../../components/table-contact-user';
import { ASSIGNTYPEENUM, lintShowNum, computedIsEmpty } from './../daily-goods-strategy-config';
import './index.less';
import IconTip from '@/components/icon-tip';

const DailyGoodsStrategyTable = withRouter((props) => {
  const { onSureGoodsNum, tableData } = props;
  const activityId = getQuery('activityId');
  const { roomId, dailyData } = useContext(ContextProviderMenus);

  /* showClumns */
  const showClumns = [
    {
      title: '商品策略/ID',
      dataIndex: 'info',
      key: 'info',
      fixed: 'left',
      width: 300,
      render: (value, { jobName, jobId }) => {
        return <TableContentCopy keyContent={jobName} valContent={jobId} showDoint={false} colon={false} />;
      },
    },
    {
      title: '类型',
      dataIndex: 'type',
      key: 'type',
      render: (value, { type }) => {
        return <>{type ? <div className="custom-col-cell">{ASSIGNTYPEENUM[type]?.name}</div> : '-'}</>;
      },
    },
    {
      title: (
        <>
          <span className="title-component-txt" style={{ marginRight: '5px' }}>
            商品数
            <IconTip
              title={`数据口径说明：商品数是盘货完成时刻的sku数量固定不变，详情中运营数据看板的sku数量为实时变化，可能存在数值不一致的情况`}
              type="question"
            />
          </span>
        </>
      ),
      daitaIndex: 'wareCount',
      key: 'wareCount',
      render: (value, { wareCount }) => {
        return (
          <>{!computedIsEmpty(wareCount) ? <div className="custom-col-cell">{lintShowNum(wareCount)}</div> : '-'}</>
        );
      },
    },
    {
      title: '子策略',
      dataIndex: 'ruleGroups',
      key: 'ruleGroups',
      render: (value, { ruleGroups }) => {
        if (ruleGroups && Array.isArray(ruleGroups) && ruleGroups.length > 0) {
          const filterNameArray = ruleGroups.map((item) => item?.ruleGroupName);
          return <div className="custom-col-cell">{filterNameArray.join('、')}</div>;
        } else {
          return '-';
        }
      },
    },
    {
      title: '创建人',
      dataIndex: 'createUser',
      key: 'createUser',
      render: (value, { createdByCN, createBy }) => {
        return <TableContactUser userName={createdByCN} userErp={createBy} />;
      },
    },
    {
      title: '策略说明',
      dataIndex: 'jobDescription',
      key: 'jobDescription',
      ellipsis: true,
      render: (value, { jobDescription }) => {
        return <>{jobDescription ? jobDescription : '-'}</>;
      },
    },
    {
      title: '操作',
      key: 'action',
      fixed: 'right',
      width: 200,
      render: (value, item) => {
        const {
          ruleGroups, // 子策略
          noticed, // 触达状态：0-未触达；1-触达
          // noticeScope, // 0-全量触达；1-部分触达
        } = item;

        return (
          <div className="buttons-fa">
            <>
              <Button type="link" onClick={() => operateBtn('detail', item)} className="buttons-item">
                详情
              </Button>
              {noticed ? (
                <Button type="link" onClick={() => operateBtn('touchDetail', item)} className="buttons-item">
                  素材维护详情
                </Button>
              ) : (
                <Button type="link" onClick={() => operateBtn('touchSet', item)} className="buttons-item">
                  素材维护触达
                </Button>
              )}
            </>
          </div>
        );
      },
    },
  ];

  /* 操作【统一switch,后期可以拓展更多按钮】 */
  function operateBtn(type, item) {
    const { jobId, ruleId, createBy, jobName, ruleGroups, noticeScope } = item;
    const { endTime } = dailyData;

    switch (type) {
      case 'detail': //详情流程
        goto
          .dailyGoodsStrategyDetail({
            activityId,
            name: jobName,
            roomId,
            jid: jobId,
            createdBy: createBy,
            formCreate: false,
          })
          .newTab();
        break;
      case 'touchSet': //素材维护触达
        if (!(ruleGroups && Array.isArray(ruleGroups) && ruleGroups.length > 0)) {
          Modal.info({
            title: '目前策略下暂无商品，请先配置！',
            content: '',
            mask: false,
          });
        } else {
          // 排查一下商品数据有了没，有了才可以跳
          onSureGoodsNum(item)?.then((res) => {
            // 存在且小于30万
            if (res[0] && res[1] && Number(res[1]) < 300000) {
              goto.dailyGoodsStrategyTouchSet(activityId, roomId, endTime, item).push();
            } else {
              if (res[1] && Number(res[1]) >= 300000) {
                message.warning({
                  content: '商品数超过30万，请缩小策略数量后再进行素材维护！',
                  className: 'custom-class',
                  style: {
                    marginTop: '10vh',
                  },
                });
              } else {
                message.warning({
                  content:
                    '请先在策略详情-运营数据看板中完成盘货，并且盘货状态为提交完成，之后可进行素材维护触达。数据传输可能需要一些时间，请耐心等待~',
                  className: 'custom-class',
                  style: {
                    marginTop: '10vh',
                  },
                });
              }
            }
          });
        }
        break;
      case 'touchDetail': //素材维护详情
        // noticeScope, 0-全量触达；1-部分触达
        goto.dailyGoodsStrategyTouchDetail(activityId, roomId, jobId, ruleId, noticeScope).newTab();
        break;
      default:
        break;
    }
  }

  return (
    <div className="daily-goods-strategy-table-fa">
      <Table
        scroll={{ x: 1200 }}
        columns={showClumns}
        rowKey={({ jobId }) => jobId}
        dataSource={tableData?.data}
        pagination={false}
      />
    </div>
  );
});

export default DailyGoodsStrategyTable;
